import {IMailQueueAdminEntryFilter, MailQueueEntryState} from "@/models/mail-queue/MailQueueAdminModels";
import IListFilter from "@/models/IListFilter";

export default class MailQueueAdminListFilter implements IMailQueueAdminEntryFilter, IListFilter {
	public state: MailQueueEntryState | null = null;

	public clear(): void {
		this.state = null;
	}

	public hasFilter(): boolean {
		return this.state !== null;
	}
}